import { HttpErrorResponse } from '@angular/common/http';
import { StateContext } from '@ngxs/store';
import { OperatorFunction } from 'rxjs';

import { Booking, BookingResponse, BookingStateModel } from 'libs/booking/data-access/src/lib/models';
import { SnackbarService } from '@fitscovery/ui/snackbar';
import { catchError } from 'rxjs/operators';

export class BookingControlState {

  constructor(
    public snackbar: SnackbarService
  ) { }

  get catchResponse(): OperatorFunction<unknown, unknown> {
    return catchError((response: HttpErrorResponse) => {
      this.snackbar.openSnack({ message: response.error?.errors[0], duration: 5000 });
      throw new Error(response.error?.errors[0]);
    })
  }

  updateBookingStatus(ctx: StateContext<BookingStateModel>, bookingResponse: BookingResponse): Booking[] {
    const id = bookingResponse.data.id;
    const status = bookingResponse.data.status;
    return ctx.getState().bookings!.map((booking: Booking) => {
      if (booking.id === id) {
        booking.status = status;
        return booking;
      } else {
        return booking;
      }
    });
  }

}
